export default {"src":"/_next/static/media/info-icon.959830ec.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};